import useTourManager from '../../hooks/useTourManager';
import { tourSteps } from '../../config/dietRequestsConfig';

const useDietRequestsTour = ({
  isAuthenticated,
  data,
  showHorizontalPager,
  setShowHorizontalPager,
  horizontalPages,
  hasSeenNavbarTour,
  setShowPinIconsForTour
}) => {
  // Pre-tour setup function
  const onTourStart = () => {
    // Ensure horizontal pager is visible for tour
    if (!showHorizontalPager && horizontalPages > 1) {
      setShowHorizontalPager(true);
    }
  };

  // Custom tour event handlers
  const onBeforeChange = (targetElement, targetIndex, steps) => {
    // Show pin icons during the column pinning tour step
    const currentStep = steps[targetIndex];
    if (currentStep && currentStep.element === '[data-intro="pin-icon"]') {
      setShowPinIconsForTour(true);
    } else {
      setShowPinIconsForTour(false);
    }
  };

  const onComplete = () => {
    setShowPinIconsForTour(false); // Hide pin icons when tour completes
  };

  const onExit = () => {
    setShowPinIconsForTour(false); // Hide pin icons when tour exits
  };

  // Use shared tour manager with custom logic
  const { startTour } = useTourManager({
    tourName: 'dietRequestsTour',
    cookieName: 'dietRequestsTourSeen',
    isAuthenticated,
    dataReady: data.length > 0,
    hasSeenNavbarTour,
    pageSteps: tourSteps,
    onTourStart,
    onBeforeChange,
    onComplete,
    onExit
  });

  return { startTour };
};

export default useDietRequestsTour;
